module.exports = __webpack_public_path__ + "static/media/21ECLAC5.8e9cc536.jpg";